import * as Sentry from '@sentry/browser';

export const setTag = (key, value) => {
  Sentry.getCurrentScope().setTag(key, value);
};
